import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DateTimePicker from "@mui/lab/DateTimePicker";
// import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CardDataLoader from "../../../../uiComponents/CardDataLoader/CardDataLoader";
import { laravelToJsDateFormat } from "../../../../utility/dateConversion";

const axios = require("axios").default;
const { zonedTimeToUtc, utcToZonedTime, format } = require("date-fns-tz");

const BillTransaction = () => {
  const dispatch = useDispatch();
  const transactionList = useSelector((state) => state.transactionList);
  const totalPaid = useSelector((state) => state.paid);
  const masterPaid = useSelector((state) => state.masterPaid);

  const [transactionDate, setTransactionDate] = React.useState([]);
  const [transactionAmount, setTransactionAmount] = React.useState([]);
  const [payBy, setPayBy] = React.useState("Cash");
  const [isLoading, setIsLoading] = React.useState(false);

  // getTransaction History

  // handleTransactionUpdate
  const handleTransactionUpdate = (item, index) => {
    const totalIncrement = masterPaid - totalPaid;
    alert(totalIncrement);
    return;

    console.log("item", item);
    const newDate3Temp = new Date(transactionDate[index]);
    const newDate3 = zonedTimeToUtc(newDate3Temp, "Asia/Dhaka");
    // const newDate3 = zonedTimeToUtc(newDate3Temp, 'Europe/Berlin');
    console.log("newDate3Temp", newDate3Temp);
    console.log("newDate3", newDate3);

    // const newDate2 = format(new Date(transactionDate[index]), "yyyy-MM-dd");
    // console.log("newDate2", newDate2);
    // const newDate = new Date(transactionDate[index])
    // const utcDate = zonedTimeToUtc(newDate, 'Asia/Dhaka')
    // console.log("transactionDate", transactionDate[index], newDate, utcDate);
    console.log("transactionAmount", transactionAmount[index]);
    console.log("payBy", payBy[index]);

    const payload = {
      tr_amount: transactionList[index]["tr_amount"],
      payment_type: payBy[index],
      created_at: newDate3Temp,
    };
    //

    setIsLoading(true);
    axios
      .put("/billing-order/update-transaction/" + item.id + "/" + totalPaid, {
        ...payload,
      })
      .then((response) => {
        setIsLoading(false);
        console.log(response);
        toast.success("Transaction data updated");
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };
  // handleTransactionDelete
  const handleTransactionDelete = () => {};

  useEffect(() => {
    console.log("transactionList", transactionList);
    // load data
    let tempTotalPaid = 0;
    transactionList.map((item, index) => {
      // amount
      const newTempDateArray = [...transactionDate];
      const newTempDate = new Date(item.created_at);
      const newDate = laravelToJsDateFormat(item.created_at);

      console.log("newDate---", typeof newDate, newDate, newTempDate);
      newTempDateArray[index] = newTempDate;
      setTransactionDate(newTempDateArray);
      // amount
      const newTempTran = [...transactionAmount];
      newTempTran[index] = item.tr_amount;
      setTransactionAmount(newTempTran);

      // pay by
      const newTempPaidBy = [...payBy];
      newTempPaidBy[index] = item.payment_type;
      setPayBy(newTempPaidBy);
      // calucalte total amount
      tempTotalPaid += parseInt(item.tr_amount);
      dispatch({
        type: "paid_update",
        payload: tempTotalPaid,
      });
    });
  }, [transactionList]);

  const removeItemFromTransactionList = (index) => {
    dispatch({
      type: "transactionList_remove",
      payload: index,
    });
  };

  return (
    <Box
      sx={{
        marginLeft: "16px",
        padding: "10px",
        borderRadius: 2,
        bgcolor: "#f3f3f3",
        position: "relative",
      }}
    >
      <h4>Transaction History</h4>
      <table>
        {/* <tr>
          <th>Date</th>
          <th>Amount</th>
          <th>Pay By</th>
          <th>Action</th>
        </tr> */}
        {transactionList.map((item, index) => {
          return (
            <tr key={index} style={{ display: "flex", alignItems: "center" }}>
              <td style={{ paddingTop: "15px" }}>
                {/* <input type="date" className="form-control" /> */}

                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="DD-MM-YYYY"
                    label="Tran. Date"
                    value={transactionDate[index]}
                    onChange={(newValue) => {
                      const newTempDate = [...transactionDate];
                      newTempDate[index] = newValue;
                      setTransactionDate(newTempDate);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider> */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    label="Tran. Date"
                    value={transactionDate[index]}
                    onChange={(newValue) => {
                      const newTempDate = [...transactionDate];
                      newTempDate[index] = newValue;
                      setTransactionDate(newTempDate);
                    }}
                    renderInput={(params) => (
                      <TextField size="small" {...params} sx={{}} />
                    )}
                  />
                </LocalizationProvider>
              </td>
              <td style={{ paddingTop: "15px" }}>
                {/* <input type="text" className="form-control" /> */}
                <TextField
                  sx={{ mx: 1, width: "120px" }}
                  size="small"
                  label="Amount"
                  value={transactionList[index]["tr_amount"]}
                  defaultValue={item.tr_amount}
                  onChange={(event) => {
                    const tempTransactionList = [...transactionList];
                    tempTransactionList[index]["tr_amount"] =
                      event.target.value;
                    setTransactionAmount(tempTransactionList);
                    //
                    let tempTotalPaid = 0;
                    transactionList.map((item) => {
                      tempTotalPaid += parseInt(item.tr_amount);
                    });
                    dispatch({
                      type: "paid_update",
                      payload: tempTotalPaid,
                    });
                  }}
                  // onChange={(event) => {
                  //   const newTempTran = [...transactionAmount];
                  //   newTempTran[index] = event.target.value;
                  //   setTransactionAmount(newTempTran);
                  // }}
                ></TextField>
              </td>
              {/* setPayBy */}
              <td style={{ paddingTop: "15px" }}>
                <select
                  value={payBy[index]}
                  defaultValue={payBy[index]}
                  onChange={(event) => {
                    const tempArray = [...payBy];
                    tempArray[index] = event.target.value;
                    setPayBy(tempArray);
                  }}
                >
                  <option>Cash</option>
                  <option>Card</option>
                  <option>Bkash</option>
                  <option>Rocket </option>
                  <option>Nogod</option>
                </select>
              </td>
              <td style={{ paddingTop: "15px", paddingLeft: "15px" }}>
                <Button
                  onClick={() => removeItemFromTransactionList(index)}
                  variant="outlined"
                  color="error"
                  size="small"
                >
                  X
                </Button>
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                  title="SAVE DATA"
                    sx={{ p: "10px",  color:"lime"  }}
                    onClick={() => handleTransactionUpdate(item, index)}
                  >
                    <CreateNewFolderOutlinedIcon></CreateNewFolderOutlinedIcon>
                    </IconButton>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                  title="Delete This transaction"
                    sx={{ p: "10px", color:"red" }}
                   
                  >
                    <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                    </IconButton>
                  
                </div> */}
              </td>
            </tr>
          );
        })}
      </table>
      {isLoading && <CardDataLoader></CardDataLoader>}
    </Box>
  );
};

export default BillTransaction;
